export default class MenuCarouselCard extends React.Component {
    constructor(props) {
        super(props);
        this.carouselCard = this.props.CardItem;
    }
    render() {
        return (
            
                        
            <div className="item carousel-item">
                {this.carouselCard.IsClickable &&
                    <div className="home-features__item home-features__item--eggs-benedicts">
                        <a href={this.carouselCard.CTALinkUrl} className="home-features__item-link" target={this.carouselCard.CTALinkTarget}>
                            <div className="home-features__figure">
                                <img src={this.carouselCard.ImageUrl} alt={this.carouselCard.ImageAlt} aria-hidden="true" className="home-features__image" width="448" height="300" loading="lazy" />
                            </div>
                            <div className="home-features__content">
                                <h2 className="home-features__title">{this.carouselCard.Title}</h2>
                                <p className="home-features__copy">{this.carouselCard.Description}</p>
                            {this.carouselCard.CTALinkText &&
                                <div className="home-features__cta">
                                    <div className="cta-button">
                                        <span className="cta-button__text">{this.carouselCard.CTALinkText}</span>
                                    </div>
                                </div>
                            }
                            </div>
                        </a>
                    </div>

                }
                {!this.carouselCard.IsClickable &&
                    <div className="home-features__item home-features__item--eggs-benedicts">
                        <div className="home-features__figure">
                            <img src={this.carouselCard.ImageUrl} alt={this.carouselCard.ImageAlt} aria-hidden="true" className="home-features__image" width="448" height="300" loading="lazy" />
                        </div>
                        <div className="home-features__content">
                            <h2 className="home-features__title">{this.carouselCard.Title}</h2>
                        <p className="home-features__copy">{this.carouselCard.Description}</p>
                        {this.carouselCard.CTALinkText &&
                            <div className="home-features__cta">
                                <div className="cta-button">
                                    <span className="cta-button__text">{this.carouselCard.CTALinkText}</span>
                                </div>
                            </div>
                        }
                        </div>                    
                    </div>
                }
                                
            </div>
                    
        );
    }
}